import PortalVue from 'portal-vue';
import {InertiaApp} from '@inertiajs/inertia-vue';
import TextareaAutosize from 'vue-textarea-autosize';

import * as Sentry from '@sentry/browser';
import {Vue as VueIntegration} from '@sentry/integrations';
import {Integrations} from '@sentry/tracing';
import Vue from 'vue';
import store from './Store/index';
import './Plugins/All';
import './Mixins/All';
import './filters';

Sentry.init({
    dsn: process.env.MIX_SENTRY_DSN,
    integrations: [
        new VueIntegration({
            Vue,
            tracing: true
        }),
        new Integrations.BrowserTracing()
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 0.0
});

Vue.config.productionTip = false;
Vue.mixin({ methods: { route: window.route } });
Vue.use(InertiaApp);
Vue.use(PortalVue);
Vue.use(TextareaAutosize);

Vue.use(InertiaApp);
let app = document.getElementById('app');

new Vue({
    store,
    render: h =>
        h(InertiaApp, {
            props: {
                initialPage: JSON.parse(app.dataset.page),
                resolveComponent: name => {
                    return import(`@/Pages/${name}`).then(
                        module => module.default
                    );
                }
            }
        })
}).$mount(app);
